import type { Theme } from '@emotion/react';
import { Container as MuiContainer, type SxProps } from '@mui/material';

interface ContainerProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}

export const Container = ({ children, sx, maxWidth = 'xl' }: ContainerProps) => (
  <MuiContainer maxWidth={maxWidth} sx={{ py: 4, px: 3, minHeight: 'calc(100vh - 64px)', ...sx }}>
    {children}
  </MuiContainer>
);
